<script setup>
import { computed } from "vue";

const props = defineProps({
  filledBars: {
    type: Number,
    required: true,
    default: 0
  }
});

// SVG paths for 50 individual rounded pill-shaped bars
// Each bar is 4px wide with 4px spacing (8px total per bar)
const barPaths = [
  "M2 0C3.10457 6.44256e-08 4 0.895431 4 2L4 55C4 56.1046 3.10457 57 2 57C0.895431 57 0 56.1046 0 55L0 2C0 0.895431 0.895431 0 2 0Z",
  "M10 0C11.1046 6.44257e-08 12 0.895431 12 2L12 55C12 56.1046 11.1046 57 10 57C8.89543 57 8 56.1046 8 55L8 2C8 0.895431 8.89543 0 10 0Z",
  "M18 0C19.1045 5.05724e-05 20 0.895462 20 2L20 55C20 56.1045 19.1045 57 18 57C16.8954 57 16 56.1046 16 55L16 2C16 0.895431 16.8954 0 18 0Z",
  "M26 0C27.1046 0 28 0.895431 28 2L28 55C28 56.1046 27.1046 57 26 57C24.8955 57 24 56.1046 24 55L24 2C24 0.895446 24.8955 2.46746e-05 26 0Z",
  "M34 0C35.1045 2.48034e-05 36 0.895446 36 2L36 55C36 56.1046 35.1045 57 34 57C32.8954 57 32 56.1046 32 55L32 2C32 0.895431 32.8954 0 34 0Z",
  "M42 0C43.1046 0 44 0.895431 44 2L44 55C44 56.1046 43.1046 57 42 57C40.8955 57 40 56.1045 40 55L40 2C40 0.895461 40.8955 4.94128e-05 42 0Z",
  "M50 0C51.1046 6.44257e-08 52 0.895431 52 2L52 55C52 56.1046 51.1046 57 50 57C48.8954 57 48 56.1046 48 55L48 2C48 0.895431 48.8954 0 50 0Z",
  "M58 0C59.1045 4.95416e-05 60 0.895461 60 2L60 55C60 56.1045 59.1045 57 58 57C56.8954 57 56 56.1046 56 55L56 2C56 0.895431 56.8954 0 58 0Z",
  "M66 0C67.1046 0 68 0.895431 68 2L68 55C68 56.1046 67.1046 57 66 57C64.8955 57 64 56.1046 64 55L64 2C64 0.895446 64.8955 2.46746e-05 66 0Z",
  "M74 0C75.1045 2.48034e-05 76 0.895446 76 2L76 55C76 56.1046 75.1045 57 74 57C72.8954 57 72 56.1046 72 55L72 2C72 0.895431 72.8954 0 74 0Z",
  "M82 0C83.1046 0 84 0.895431 84 2L84 55C84 56.1046 83.1046 57 82 57C80.8955 57 80 56.1045 80 55L80 2C80 0.895461 80.8955 4.94128e-05 82 0Z",
  "M90 0C91.1046 6.44257e-08 92 0.895431 92 2L92 55C92 56.1046 91.1046 57 90 57C88.8954 57 88 56.1046 88 55L88 2C88 0.895431 88.8954 0 90 0Z",
  "M98 0C99.1045 4.95416e-05 100 0.895461 100 2L100 55C100 56.1045 99.1045 57 98 57C96.8954 57 96 56.1046 96 55L96 2C96 0.895431 96.8954 0 98 0Z",
  "M106 0C107.105 0 108 0.895431 108 2L108 55C108 56.1046 107.105 57 106 57C104.895 57 104 56.1046 104 55L104 2C104 0.895446 104.895 2.46746e-05 106 0Z",
  "M114 0C115.105 2.48034e-05 116 0.895446 116 2L116 55C116 56.1046 115.105 57 114 57C112.895 57 112 56.1046 112 55L112 2C112 0.895431 112.895 0 114 0Z",
  "M122 0C123.105 0 124 0.895431 124 2L124 55C124 56.1046 123.105 57 122 57C120.895 57 120 56.1045 120 55L120 2C120 0.895461 120.895 4.94128e-05 122 0Z",
  "M130 0C131.105 6.44257e-08 132 0.895431 132 2V55C132 56.1046 131.105 57 130 57C128.895 57 128 56.1046 128 55V2C128 0.895431 128.895 0 130 0Z",
  "M138 0C139.105 4.95416e-05 140 0.895461 140 2V55C140 56.1045 139.105 57 138 57C136.895 57 136 56.1046 136 55V2C136 0.895431 136.895 0 138 0Z",
  "M146 0C147.105 0 148 0.895431 148 2V55C148 56.1046 147.105 57 146 57C144.895 57 144 56.1046 144 55V2C144 0.895446 144.895 2.46746e-05 146 0Z",
  "M154 0C155.105 2.48034e-05 156 0.895446 156 2V55C156 56.1046 155.105 57 154 57C152.895 57 152 56.1046 152 55V2C152 0.895431 152.895 0 154 0Z",
  "M162 0C163.105 0 164 0.895431 164 2V55C164 56.1046 163.105 57 162 57C160.895 57 160 56.1045 160 55V2C160 0.895461 160.895 4.94128e-05 162 0Z",
  "M170 0C171.105 6.44257e-08 172 0.895431 172 2V55C172 56.1046 171.105 57 170 57C168.895 57 168 56.1046 168 55V2C168 0.895431 168.895 0 170 0Z",
  "M178 0C179.105 4.95416e-05 180 0.895461 180 2V55C180 56.1045 179.105 57 178 57C176.895 57 176 56.1046 176 55V2C176 0.895431 176.895 0 178 0Z",
  "M186 0C187.105 0 188 0.895431 188 2V55C188 56.1046 187.105 57 186 57C184.895 57 184 56.1046 184 55V2C184 0.895446 184.895 2.46746e-05 186 0Z",
  "M194 0C195.105 2.48034e-05 196 0.895446 196 2V55C196 56.1046 195.105 57 194 57C192.895 57 192 56.1046 192 55V2C192 0.895431 192.895 0 194 0Z",
  "M202 0C203.105 0 204 0.895431 204 2V55C204 56.1046 203.105 57 202 57C200.895 57 200 56.1045 200 55V2C200 0.895461 200.895 4.94128e-05 202 0Z",
  "M210 0C211.105 6.44257e-08 212 0.895431 212 2V55C212 56.1046 211.105 57 210 57C208.895 57 208 56.1046 208 55V2C208 0.895431 208.895 0 210 0Z",
  "M218 0C219.105 4.95416e-05 220 0.895461 220 2V55C220 56.1045 219.105 57 218 57C216.895 57 216 56.1046 216 55V2C216 0.895431 216.895 0 218 0Z",
  "M226 0C227.105 0 228 0.895431 228 2V55C228 56.1046 227.105 57 226 57C224.895 57 224 56.1046 224 55V2C224 0.895446 224.895 2.46746e-05 226 0Z",
  "M234 0C235.105 2.48034e-05 236 0.895446 236 2V55C236 56.1046 235.105 57 234 57C232.895 57 232 56.1046 232 55V2C232 0.895431 232.895 0 234 0Z",
  "M242 0C243.105 0 244 0.895431 244 2V55C244 56.1046 243.105 57 242 57C240.895 57 240 56.1045 240 55V2C240 0.895461 240.895 4.94128e-05 242 0Z",
  "M250 0C251.105 6.44257e-08 252 0.895431 252 2V55C252 56.1046 251.105 57 250 57C248.895 57 248 56.1046 248 55V2C248 0.895431 248.895 0 250 0Z",
  "M258 0C259.105 4.95416e-05 260 0.895461 260 2V55C260 56.1045 259.105 57 258 57C256.895 57 256 56.1046 256 55V2C256 0.895431 256.895 0 258 0Z",
  "M266 0C267.105 0 268 0.895431 268 2V55C268 56.1046 267.105 57 266 57C264.895 57 264 56.1045 264 55V2C264 0.895451 264.895 3.29207e-05 266 0Z",
  "M274 0C275.105 3.30496e-05 276 0.895451 276 2V55C276 56.1045 275.105 57 274 57C272.895 57 272 56.1046 272 55V2C272 0.895431 272.895 0 274 0Z",
  "M282 0C283.105 0 284 0.895431 284 2V55C284 56.1046 283.105 57 282 57C280.895 57 280 56.1045 280 55V2C280 0.895461 280.895 4.94128e-05 282 0Z",
  "M290 0C291.105 6.44257e-08 292 0.895431 292 2V55C292 56.1046 291.105 57 290 57C288.895 57 288 56.1046 288 55V2C288 0.895431 288.895 0 290 0Z",
  "M298 0C299.105 4.95416e-05 300 0.895461 300 2V55C300 56.1045 299.105 57 298 57C296.895 57 296 56.1046 296 55V2C296 0.895431 296.895 0 298 0Z",
  "M306 0C307.105 0 308 0.895431 308 2V55C308 56.1046 307.105 57 306 57C304.895 57 304 56.1045 304 55V2C304 0.895451 304.895 3.29207e-05 306 0Z",
  "M314 0C315.105 3.30496e-05 316 0.895451 316 2V55C316 56.1045 315.105 57 314 57C312.895 57 312 56.1046 312 55V2C312 0.895431 312.895 0 314 0Z",
  "M322 0C323.105 0 324 0.895431 324 2V55C324 56.1046 323.105 57 322 57C320.895 57 320 56.1045 320 55V2C320 0.895461 320.895 4.94128e-05 322 0Z",
  "M330 0C331.105 6.44256e-08 332 0.895431 332 2V55C332 56.1046 331.105 57 330 57C328.895 57 328 56.1046 328 55V2C328 0.895431 328.895 0 330 0Z",
  "M338 0C339.105 4.95416e-05 340 0.895461 340 2V55C340 56.1045 339.105 57 338 57C336.895 57 336 56.1046 336 55V2C336 0.895431 336.895 0 338 0Z",
  "M346 0C347.105 0 348 0.895431 348 2V55C348 56.1046 347.105 57 346 57C344.895 57 344 56.1045 344 55V2C344 0.895451 344.895 3.29207e-05 346 0Z",
  "M354 0C355.105 3.30496e-05 356 0.895451 356 2V55C356 56.1045 355.105 57 354 57C352.895 57 352 56.1046 352 55V2C352 0.895431 352.895 0 354 0Z",
  "M362 0C363.105 0 364 0.895431 364 2V55C364 56.1046 363.105 57 362 57C360.895 57 360 56.1045 360 55V2C360 0.895461 360.895 4.94128e-05 362 0Z",
  "M370 0C371.105 6.44256e-08 372 0.895431 372 2V55C372 56.1046 371.105 57 370 57C368.895 57 368 56.1046 368 55V2C368 0.895431 368.895 0 370 0Z",
  "M378 0C379.105 4.95416e-05 380 0.895461 380 2V55C380 56.1045 379.105 57 378 57C376.895 57 376 56.1046 376 55V2C376 0.895431 376.895 0 378 0Z",
  "M386 0C387.105 0 388 0.895431 388 2V55C388 56.1046 387.105 57 386 57C384.895 57 384 56.1045 384 55V2C384 0.895451 384.895 3.29207e-05 386 0Z",
  "M394 0C395.105 3.30496e-05 396 0.895451 396 2V55C396 56.1045 395.105 57 394 57C392.895 57 392 56.1046 392 55V2C392 0.895431 392.895 0 394 0Z"
];

// Calculate how many pixels of the gradient should be visible
// Formula: (number of filled bars / total bars) * total width
const filledWidth = computed(() => (props.filledBars / 50) * 396);
</script>

<template>
  <svg
    width="396"
    height="57"
    viewBox="0 0 396 57"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="tw-w-full tw-h-full"
  >
    <defs>
      <!-- Gradient: Primary color to Primary-200, left to right -->
      <linearGradient
        id="paint0_linear_1_1613"
        x1="0"
        y1="28.5"
        x2="396"
        y2="28.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0%"
          class="tw-stop-primary"
        />
        <stop
          offset="100%"
          class="tw-stop-primary-200"
        />
      </linearGradient>

      <!-- Mask: Shapes the gradient to only show within the bar shapes -->
      <mask
        id="mask0_1_1509"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="396"
        height="57"
      >
        <path
          v-for="(path, index) in barPaths"
          :key="`mask-${index}`"
          :d="path"
          fill="#D9D9D9"
        />
      </mask>
    </defs>

    <g clip-path="url(#clip0_1_1509)">
      <!-- Layer 1: Grey background bars (always visible) -->
      <path
        v-for="(path, index) in barPaths"
        :key="`bg-${index}`"
        :d="path"
        fill="#DBDBDB"
      />

      <!-- Layer 2: Gradient overlay (reveals from left to right) -->
      <g mask="url(#mask0_1_1509)">
        <rect
          y="-1"
          width="396"
          height="59"
          fill="url(#paint0_linear_1_1613)"
          :style="{ clipPath: `inset(0 ${396 - filledWidth}px 0 0)` }"
          class="tw-transition-all tw-duration-500"
        />
      </g>
    </g>
  </svg>
</template>

<style>
/* Tailwind primary colors for gradient stops */
.tw-stop-primary {
  stop-color: #2F52E0;
}

.tw-stop-primary-200 {
  stop-color: #A6C3FF;
}
</style>

